import React, {useCallback, useMemo} from 'react';
import Field from '../Field';
import Settings from '../Settings';
import Statistics from '../Statistics';
import useGameController from '../../hooks/useGameController';
import {GameState, SettingsLevel} from '../../types';

import style from './style.module.css';

export default function Game() {
  const {
    settings,
    setSettingsByLevel,
    fields,
    onFieldOpen,
    formattedTimer,
    prepareGame,
    continuePlaying,
    pause,
    gameState,
    flagsCount,
    setFlag,
    deleteFlag,
  } = useGameController();

  const playButtonLabel = useMemo(() => {
    switch (gameState) {
      case GameState.Idle:
        return 'Oyna';
      default:
        return 'Tekrar Oyna';
    }
  }, [gameState]);

  const pauseButtonLabel = useMemo(() => {
    switch (gameState) {
      case GameState.Pause:
        return 'Devam Et';
      default:
        return 'Durdur';
    }
  }, [gameState]);

  const fieldsStyle = useMemo(
    () => ({
      gridTemplateColumns: `repeat(${settings.xFieldsCount}, 1fr)`,
      gridTemplateRows: `repeat(${settings.yFieldsCount}, 1fr)`,
    }),
    [settings],
  );

  const handlePauseButtonClick = useCallback(() => {
    if (gameState === GameState.Pause) {
      continuePlaying();
    } else {
      pause();
    }
  }, [gameState, pause, continuePlaying]);

  return (
    <>
            <aside className={style.aside}>
          <div className={style.stats}>
            <Statistics value={formattedTimer} icon="🕑" title="Süren" />&nbsp;&nbsp;&nbsp;&nbsp;
            <Statistics
              value={`${settings.bombsCount - flagsCount}/${settings.bombsCount}`}
              icon="🚩"
              title="Kalan Bayrakların"
            />&nbsp;&nbsp;&nbsp;&nbsp;
          <div className={style.buttonWrapper}>
            {gameState === GameState.Playing || gameState === GameState.Idle || (
              <button className={style.button} onClick={prepareGame}>
                {playButtonLabel}
              </button>
            )}
            {(gameState === GameState.Playing || gameState === GameState.Pause) && (
              <button className={style.button} onClick={handlePauseButtonClick}>
                {pauseButtonLabel}
              </button>
            )}
          </div>
          </div>
        </aside>
      <Settings level={settings.level} onLevelChange={setSettingsByLevel} />
      <section className={style.fields} style={fieldsStyle}>
          {Array.from(fields.values()).map((field) => (
            <Field
              key={field.id}
              field={field}
              gameState={gameState}
              onOpen={onFieldOpen}
              onSetFlag={setFlag}
              onDeleteFlag={deleteFlag}
              isSmall={settings.level !== SettingsLevel.Beginner}
            />
          ))}
        </section>
    </>
  );
}
